import { render, staticRenderFns } from "./MaterialRevealCard.vue?vue&type=template&id=69b0054a"
import script from "./MaterialRevealCard.vue?vue&type=script&lang=js"
export * from "./MaterialRevealCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialRevealCard.vue?vue&type=style&index=0&id=69b0054a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports